import styled from 'styled-components';
import { Link } from 'gatsby';

export const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 60px 0 0;
  z-index: 109;
  height: 90px;
  transform: translate3d(0, 0, 0);
  transition: all 0.3s;
  background: transparent;
  display: ${({ isScollTop, isMenuOpen }) =>
    isScollTop || isMenuOpen ? 'block' : 'none'};
  will-change: display;
  .container {
    position: ${({ isMenuOpen }) => (isMenuOpen ? 'fixed' : 'relative')};
    opacity: ${({ isScollTop }) => (isScollTop ? 1 : 0)};
    transition: all 0.2s;
    will-change: opacity;

    ${({ isMenuOpen }) =>
    isMenuOpen &&
    `
      top: 60px;
      left: 0;
      right: 0;
      opacity: 1;
    `}
  }

  @media only screen and (max-width: 990px) {
    padding: 35px 0 70px;

    ${({ isMenuOpen }) =>
    isMenuOpen &&
    `
      background: #0a090b;
    `}

    .container {
      ${({ isMenuOpen }) =>
    isMenuOpen &&
    `
        top: 35px;
      `}
    }
  }

  @media only screen and (max-width: 767px) {
    top: 0px !important;
  }
`;

export const MenuButton = styled.button`
  position: fixed;
  top: 25px;
  left: -25px;
  color: ${({ theme: { colors } }) => colors.white};
  font-size: 13px;
  line-height: 16px;
  background-color: ${({ theme: { colors } }) => colors.pink};
  z-index: 150;
  transform: rotate(270deg);
  width: 90px;
  height: 41px;
  padding: 12px 0;
  border: 0;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  will-change: color, background-color;

  &.black {
    background-color: ${({ theme: { colors } }) => colors.black};
  }

  &:hover,
  &:focus {
    background-color: ${({ theme: { colors } }) => colors.pinkHover};
    color: ${({ theme: { colors } }) => colors.white};
  }

  @media only screen and (max-width: 990px) {
    top: 60px;
    right: -19px;
    left: auto;
    font-size: 12px;
    padding: 6px 0;
    width: 66px;
    height: 29px;
  }
`;

export const CTAButton = styled(Link)`
  position: absolute;
  right: 15px;
  color: ${({ active }) => (active ? '#000000' : '#ffffff')};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.18px;
  line-height: 28px;
  background-color: ${({ active }) => (active ? '#ffffff' : 'transparent')};
  min-width: 158px;
  display: inline-block;
  text-align: center;
  padding: 6px;
  border: 1px solid ${({ active }) => (active ? '#000000' : '#ffffff')};
  border-radius: 1px;

  ${({ lightTheme, active }) =>
    lightTheme &&
    `
    color: #000000;
    border-color: ${active ? '#ffffff' : '#000000'};
  `}

  &:hover {
    background-color: #ff4552;
    color: #fff;
    border-color: #ff4552;
  }

  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

export const MegaMenu = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 100%;
  min-height: 0vh;
  max-height: 0vh;
  width: 100%;
  background-color: #0a090b;
  z-index: -1;
  overflow: auto;
  visibility: hidden;
  pointer-events: none;
  transition: 0.3s all cubic-bezier(0.4, 0, 1, 1);
  overflow-x: hidden;
  overflow-y: hidden;

  @media only screen and (max-width: 767px) {
    overflow-y: auto !important;
  }

  &::before {
    content: '';
    background-color: #fafafa;
    height: 437px;
    width: 100%;
    position: absolute;
    top: 0;
    left: calc(50% + 600px);
    opacity: 0.03;
  }

  .container {
    & > div > .row > div {
      transition: 0.3s all cubic-bezier(0.4, 0, 1, 1);
      transform: translateY(50px);
      opacity: 0;

      &:nth-child(1) {
        transition-delay: 0.1s;
      }

      &:nth-child(2) {
        transition-delay: 0.1s;
      }

      &:nth-child(3) {
        transition-delay: 0.1s;
        transition-duration: 0.3s;
      }
    }
  }

  &.show {
    bottom: 0;
    visibility: visible;
    z-index: 99;
    pointer-events: all;
    transition: 0.7s all cubic-bezier(0, 0, 0.2, 1);
    min-height: 100vh;
    max-height: 100vh;
    overflow-y: hidden;

    .container {
      & > div > .row > div {
        transition: 0.7s all cubic-bezier(0, 0, 0.2, 1);
        transform: translateY(0px);
        opacity: 1;

        &:nth-child(1) {
          transition-delay: 0.1s;
        }

        &:nth-child(2) {
          transition-delay: 0.3s;

          @media only screen and (max-width: 767px) {
            transition-delay: 0.1s;
          }
        }

        &:nth-child(3) {
          transition-delay: 0.7s;
          transition-duration: 1s;

          @media only screen and (max-width: 767px) {
            transition-delay: 0.5s;
          }
        }
      }
    }
  }

  .main-menu-nav {
    padding-top: 170px;

    @media only screen and (max-width: 990px) {
      padding-top: 130px;
    }
  }

  .menu-logo-area {
    padding: 60px 0 75px;
  }
  .nav-main-links li a {
    color: #ffffff;
    font-family: Vollkorn;
    font-size: 55px;
    letter-spacing: -0.41px;
    position: relative;
  }
  .nav-main-links li::before {
    background-color: rgba(255, 255, 255, 0.06);
    position: absolute;
    bottom: 0;
    left: -55px;
    height: 32px;
    width: 0;
    content: '';
    transition: 0.3s all ease-in-out;
  }
  .nav-main-links li:hover:before,
  .nav-main-links li.active:before {
    width: 123px;
  }
  .nav-main-links li {
    list-style-type: none;
    position: relative;
    margin-bottom: 25px;
  }
  .nav-main-links li a:hover {
    color: #ff4552;
  }
  .nav-head {
    color: #ff4552;
    font-size: 22px;
    letter-spacing: -0.16px;
    line-height: 31px;
    font-weight: 300;
    margin-bottom: 25px;
  }
  .nav-side-links li {
    list-style-type: none;
    margin-bottom: 18px;
  }
  .nav-side-links li a {
    color: #979797;
    font-size: 16px;
  }
  .nav-side-links {
    margin-bottom: 45px;
  }
  .nav-side-links li a:hover {
    color: #fff;
  }
  .nav-social-links li {
    display: inline-block;
    margin-right: 32px;
  }
  .nav-social-links li a {
    color: #979797;
    font-size: 21px;
  }
  .nav-social-links li a:hover {
    color: #fff;
  }
  .menu-area-main {
    position: fixed;
    z-index: 9999;
  }
  .nav-social-links {
    margin-bottom: 45px;
  }

  @media (max-width: 1200px) {
    .menu-logo-area {
      padding: 60px 0 55px;
    }
    .nav-main-links li a {
      font-size: 34px;
    }
    .nav-main-links li::before {
      left: -25px;
    }
  }

  @media only screen and (max-width: 979px) {
    .nav-social-links li {
      margin-right: 20px;
    }
    .nav-social-links li a {
      font-size: 17px;
    }
  }

  @media only screen and (max-width: 767px) {
    .menu-trigger {
      left: auto;
      right: -37px;
    }
    .menu-area-main {
      position: relative;
    }

    .nav-main-links li::before {
      display: none;
    }
    .nav-social-links li {
      margin: 0 10px;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

export const LogoContainer = styled.div`
  padding-left: ${(props) =>
    props.path === '/trainings/' ? '35px' : 0} !important;
  @media only screen and (max-width: 767px) {
    padding-left: ${(props) =>
    props.path === '/trainings/' ? '15px' : 0} !important;
  }
`;
